export function toggleExpandableContent(event) {
    const arrow = event.target.closest('.expander-arrow');
    if (!arrow) return; // Exit if clicked outside of an arrow

    const block = arrow.closest('.accordion-block-wrapper');
    const content = block.querySelector('.accordion-expandable-content');

    // Toggle the 'expanded' class on the content to animate the expand/collapse effect
    content.classList.toggle("expanded");

    // Check if the content is expanded after toggling the class
    const isExpanded = content.classList.contains("expanded");

    // Adjust max-height based on the expanded state
    if (isExpanded) {
        // Set max-height to a large value to expand it fully
        content.style.maxHeight = content.scrollHeight + "px";
    } else {
        // Set max-height back to 0 to collapse it
        content.style.maxHeight = 0;
    }
}